// extracted by mini-css-extract-plugin
module.exports = {"nav":"FestivalNavigation_nav__2USzm","menu":"FestivalNavigation_menu__5UPfV","active":"FestivalNavigation_active__2KBR6"};